import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/components/ui/dialog';

import { AdWizardProvider } from '../-context';
import { AdWizardForm } from './ad-wizard-form';

interface CreateAdDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Pre-selected campaign — skips the in-wizard campaign step. */
  campaignId?: string;
}

/**
 * In-page ad-creation surface: the multi-step wizard inside a standard dialog.
 * Campaigns uses this on desktop and mobile so creating an ad keeps the
 * campaign list and its filters in place.
 */
export function CreateAdDialog({
  open,
  onOpenChange,
  campaignId,
}: CreateAdDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        className="flex max-h-[calc(100dvh-2rem)] flex-col overflow-hidden sm:max-w-[560px]"
      >
        <DialogTitle className="sr-only">Create ad</DialogTitle>
        <DialogDescription className="sr-only">
          Choose the content and settings for your campaign’s ad.
        </DialogDescription>
        {/* Remount the wizard each time the dialog opens so state is fresh. */}
        {open && (
          <AdWizardProvider>
            <AdWizardForm
              preselectedCampaignId={campaignId}
              onClose={() => onOpenChange(false)}
              onComplete={() => onOpenChange(false)}
            />
          </AdWizardProvider>
        )}
      </DialogContent>
    </Dialog>
  );
}
